<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <section id="sample-page">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body pb-1">
              <div class="card-datatable text-nowrap">
                <div
                  class="d-flex mb-3"
                  style="align-items: center; justify-content: space-between"
                >
                  <div class="input-group input-group-merge w-auto">
                    <input
                      type="text"
                      id="first-name-icon"
                      class="form-control"
                      name="fname-icon"
                      placeholder="ابحث فى العروض"
                      (keyup)="updateFilter($event)"
                    />
                    <span class="input-group-text">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="10"
                          cy="10.5867"
                          r="7"
                          stroke="#3F8260"
                          stroke-opacity="0.9"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M21 21.5867L15 15.5867"
                          stroke="#3F8260"
                          stroke-opacity="0.9"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  <div class="d-flex">
                    <select
                      id="per-page"
                      class="form-control pl-3 pr-0"
                      (change)="onLimitChange($event.target.value)"
                    >
                      <option
                        *ngFor="let option of pageLimitOptions"
                        [value]="option.value"
                        [selected]="option.value == currentPageLimit"
                      >
                        {{ option.value }}
                      </option>
                    </select>
                    <button
                      class="btn btn-primary waves-effect py-0 ml-2"
                      type="button"
                      (click)="modalOpenLG(modalAddOffer); reset()"
                      rippleEffect
                    >
                      + <span class="pl-1">عرض جديد </span>
                    </button>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <ngx-datatable
                      #table
                      id="ngxTable"
                      class="material bootstrap core-bootstrap"
                      [rows]="rows"
                      [columnMode]="'force'"
                      [headerHeight]="40"
                      [footerHeight]="50"
                      [limit]="10"
                      [rowHeight]="'auto'"
                      [scrollbarH]="true"
                    >
                      <ngx-datatable-column
                        name="#"
                        prop="#"
                      ></ngx-datatable-column>
                      <ngx-datatable-column name="الفعالية" prop="eventNameEn">
                        <ng-template
                          ngx-datatable-cell-template
                          let-row="row"
                          let-value="value"
                        >
                          <select *ngIf="row.eventNameEn.length > 0" aria-readonly="true" class="form-control">
                            <option
                              *ngFor="let event of row.eventNameEn"
                              [value]="event"
                            >
                              {{ event }}
                            </option>
                          </select>
                          <select aria-readonly="true" class="form-control" *ngIf="row.eventNameEn.length == 0"><option>عرض عام</option></select>
                        </ng-template>
                      </ngx-datatable-column>
                      <ngx-datatable-column
                        name="كود العرض"
                        prop="code"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name="نسبه الخصم"
                        prop="discount"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name="عدد مرات الاستخدام"
                        prop="howManyUsed"
                      ></ngx-datatable-column>
                      <ngx-datatable-column name="الحالة" prop="isActive">
                        <ng-template
                          let-status="value"
                          ngx-datatable-cell-template
                          let-row="row"
                        >
                          <div class="d-block">
                            <div
                              class="badge badge-light-success"
                              *ngIf="row.isActive == true"
                            >
                              Active
                            </div>
                            <div
                              class="badge badge-light-danger"
                              *ngIf="row.isActive == false"
                            >
                              Stopped
                            </div>
                          </div>
                        </ng-template>
                      </ngx-datatable-column>
                      <ngx-datatable-column name="" [sortable]="false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                          <div class="d-flex align-items-center">
                            <a
                              style="color: #3f8260"
                              class="d-flex align-items-center"
                              (click)="
                                modalOpenLG(modalEditOffer); editItem(row.id)
                              "
                             title="تعديل">
                              <i data-feather="edit" class="mr-50"></i>
                            </a>
                            <a
                              style="color: #3f8260"
                              *ngIf="row.isEnabled == true"
                              class="d-flex align-items-center"
                              (click)="
                                modalOpenDefault(modalReportBlock);
                                changeOfferState(row.id, !row.isEnabled)
                              "
                             title="إلغاء التفعيل">
                              <i data-feather="slash" class="mr-50"></i>
                            </a>
                            <a
                              style="color: #3f8260"
                              *ngIf="row.isEnabled == false"
                              class="d-flex align-items-center"
                              (click)="
                                modalOpenDefault(modalReturn);
                                changeOfferState(row.id, !row.isEnabled)
                              "
                             title="رجوع">
                              <i
                                data-feather="corner-up-left"
                                class="mr-50"
                              ></i>
                            </a>
                            <a href="javascript:void(0)" class="d-flex align-items-center" (click)="deleteItem(row.id);modalOpenDefault(modalDelete)" type="button" title="حذف">
                              <i data-feather="trash-2" class="mr-50"></i>
                            </a>
                          </div>
                        </ng-template>
                      </ngx-datatable-column>
                    </ngx-datatable>
                  </div>
                </div>

                <!-- modalDelete -->
                <div class="modal-size-default d-inline-block">
                  <ng-template #modalDelete let-modal>
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel160"></h5>
                      <button
                        type="button"
                        class="close"
                        (click)="modal.dismiss('Cross click')"
                        aria-label="Close"
                       title="إغلاق">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div
                      class="modal-body text-center"
                      tabindex="0"
                      ngbAutofocus
                    >
                      <h4>تأكيد حذف العرض</h4>
                      <p class="pt-1">
                        سيتم حذف العرض . هل مازلت تريد المتابعة ؟
                      </p>
                      <div class="demo-spacing-0">
                        <div
                          class="alert alert-danger p-75"
                          role="alert"
                          dir="rtl"
                        >
                          <span
                            [data-feather]="'info'"
                            [class]="'mr-50 align-middle'"
                          ></span>
                          <span
                            >سيتم إزالة العرض ولن يكون بالإمكان استعادته
                            لاحقًا.</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer m-auto">
                      <button
                        type="button"
                        class="btn btn-danger"
                        (click)="confirmDeleteItem()"
                        rippleEffect
                      >
                        حذف
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        (click)="modal.close('Accept click')"
                        rippleEffect
                      >
                        تراجع
                      </button>
                    </div>
                  </ng-template>
                </div>

                <!-- modalReturn -->
                <div class="modal-size-default d-inline-block">
                  <ng-template #modalReturn let-modal>
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel160"></h5>
                      <button
                        type="button"
                        class="close"
                        (click)="modal.dismiss('Cross click')"
                        aria-label="Close"
                       title="إغلاق">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div
                      class="modal-body text-center"
                      tabindex="0"
                      ngbAutofocus
                    >
                      <h4>تأكيد تشغيل العرض</h4>
                      <p class="pt-1">
                        هل تريد بالتأكيد إعادة تشغيل هذا العرض؟
                      </p>
                    </div>
                    <div class="modal-footer m-auto">
                      <button
                        type="button"
                        class="btn btn-success"
                        (click)="
                          modal.close('Accept click'); confirmChangeOfferState()
                        "
                        rippleEffect
                      >
                        تشغيل
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        (click)="modal.close('Accept click')"
                        rippleEffect
                      >
                        تراجع
                      </button>
                    </div>
                  </ng-template>
                </div>

                <!-- modalReportBlock -->
                <div class="modal-size-default d-inline-block">
                  <ng-template #modalReportBlock let-modal>
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel160"></h5>
                      <button
                        type="button"
                        class="close"
                        (click)="modal.dismiss('Cross click')"
                        aria-label="Close"
                       title="إغلاق">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div
                      class="modal-body text-center"
                      tabindex="0"
                      ngbAutofocus
                    >
                      <h4>تأكيد إيقاف العرض</h4>
                      <p class="pt-1">
                        هل أنت متأكد أنك تريد إيقاف هذا العرض؟ لن يتمكن المستخدم
                        من الوصول الي هذا العرض
                      </p>
                    </div>
                    <div class="modal-footer m-auto">
                      <button
                        type="button"
                        class="btn btn-danger"
                        (click)="confirmChangeOfferState()"
                        rippleEffect
                      >
                        إيقاف
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        (click)="modal.close('Accept click')"
                        rippleEffect
                      >
                        تراجع
                      </button>
                    </div>
                  </ng-template>
                </div>

                <!-- modalAddOffer -->
                <div class="modal-size-lg d-inline-block">
                  <ng-template #modalAddOffer let-modal>
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel160"></h5>
                      <button
                        type="button"
                        class="close"
                        (click)="modal.dismiss('Cross click'); reset()"
                        aria-label="Close"
                       title="إغلاق">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body" tabindex="0" ngbAutofocus>
                      <h4 class="text-center">إضافة عرض جديد</h4>
                      <div class="demo-spacing-0">
                        <form
                          [formGroup]="offerForm"
                          class="row mt-2"
                          dir="rtl"
                        >
                          <div class="col-md-12">
                            <div class="form-check mb-2">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="isGeneral"
                                formControlName="isGeneral"
                              />
                              <label class="form-check-label" for="isGeneral"
                                >عرض عام</label
                              >
                            </div>

                            <div *ngIf="!offerForm.get('isGeneral')?.value" class="mb-1">
                              <label class="form-label" for="offerTitle"
                                >اختر الفعالية</label
                              >
                              <ng-select
                                *ngIf="eventData.length > 0"
                                [items]="eventData"
                                [multiple]="true"
                                bindLabel="nameAr"
                                bindValue="id"
                                [placeholder]="'اختر الفعالية'"
                                formControlName="eventId"
                              >
                              </ng-select>
                              <small
                                class="text-danger"
                                *ngIf="
                                  offerForm
                                    .get('eventId')
                                    ?.hasError('required') &&
                                  offerForm.get('eventId')?.touched &&
                                  eventData.length > 0
                                "
                              >
                                هذا الحقل مطلوب
                              </small>
                              <div
                                class="alert alert-danger px-3 py-1"
                                *ngIf="eventData.length == 0"
                              >
                                <p>لا توجد فعاليات متاحة حالياً</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="mb-1">
                              <label class="form-label" for="offerTitle"
                                >كود العرض</label
                              >
                              <input
                                type="text"
                                id="offerTitle"
                                class="form-control"
                                name="code"
                                formControlName="code"
                                placeholder="ادخل كود العرض"
                              />
                              <small
                                class="text-danger"
                                *ngIf="
                                  offerForm.get('code')?.hasError('required') &&
                                  offerForm.get('code')?.touched
                                "
                              >
                                هذا الحقل مطلوب
                              </small>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="mb-2">
                              <label class="form-label" for="redirectUtl"
                                >نسبه الخصم</label
                              >
                              <input
                                type="number"
                                id="redirectUtl"
                                class="form-control"
                                name="discount"
                                (input)="changeValue($event)"
                                formControlName="discount"
                                placeholder="ادخل نسبه الخصم"
                              />
                              <small
                                class="text-danger"
                                *ngIf="
                                  offerForm
                                    .get('discount')
                                    ?.hasError('required') &&
                                  offerForm.get('discount')?.touched
                                "
                              >
                                هذا الحقل مطلوب
                              </small>
                              <small
                                class="text-danger"
                                *ngIf="
                                  offerForm.get('discount')?.hasError('min') &&
                                  offerForm.get('discount')?.touched
                                "
                              >
                                يجب أن تكون النسبه أكبر من صفر
                              </small>
                              <small
                                class="text-danger"
                                *ngIf="
                                  offerForm.get('discount')?.hasError('max') &&
                                  offerForm.get('discount')?.touched
                                "
                              >
                                يجب أن تكون النسبه أقل من 100
                              </small>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="mb-2">
                              <label class="form-label" for="expiryDate"
                                >تاريخ انتهاء الصلاحية</label
                              >
                              <input
                                type="datetime-local"
                                id="expiryDate"
                                class="form-control"
                                name="expiryDate"
                                formControlName="expiryDate"
                                placeholder="ادخل تاريخ انتهاء الصلاحية"
                              />
                              <small
                                class="text-danger"
                                *ngIf="
                                  offerForm
                                    .get('expiryDate')
                                    ?.hasError('required') &&
                                  offerForm.get('expiryDate')?.touched
                                "
                              >
                                هذا الحقل مطلوب
                              </small>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div
                              class="custom-control custom-control-primary custom-switch"
                            >
                              <span class="mb-50 pr-1">تفعيل العرض</span>
                              <input
                                type="checkbox"
                                checked
                                class="custom-control-input"
                                id="customSwitch3"
                                (click)="changeState($event)"
                                name="isEnabled"
                                formControlName="isEnabled"
                              />
                              <label
                                class="custom-control-label"
                                for="customSwitch3"
                              ></label>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="modal-footer m-auto">
                      <button
                        type="button"
                        class="btn btn-success"
                        [disabled]="eventData.length == 0"
                        (click)="save()"
                        rippleEffect
                      >
                        إضافة
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        (click)="modal.close('Accept click'); reset()"
                        rippleEffect
                      >
                        تراجع
                      </button>
                    </div>
                  </ng-template>
                </div>

                <!-- modalEditOffer -->
                <div class="modal-size-lg d-inline-block">
                  <ng-template #modalEditOffer let-modal>
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel160"></h5>
                      <button
                        type="button"
                        class="close"
                        (click)="modal.dismiss('Cross click'); reset()"
                        aria-label="Close"
                       title="إغلاق">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body" tabindex="0" ngbAutofocus>
                      <h4 class="text-center">تعديل العرض</h4>
                      <div class="demo-spacing-0">
                        <form
                          [formGroup]="offerForm"
                          class="row mt-2"
                          dir="rtl"
                        >
                          <div class="col-md-12">
                            <div class="form-check mb-2">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="isGeneral"
                                formControlName="isGeneral"
                              />
                              <label class="form-check-label" for="isGeneral"
                                >عرض عام</label
                              >
                            </div>
                            <div
                              class="mb-1"
                              *ngIf="!offerForm.get('isGeneral')?.value"
                            >
                              <label class="form-label" for="offerTitle"
                                >اختر الفعالية</label
                              >
                              <ng-select
                                *ngIf="eventData.length > 0"
                                [items]="eventData"
                                [multiple]="true"
                                bindLabel="nameAr"
                                bindValue="id"
                                [placeholder]="'اختر الفعالية'"
                                formControlName="eventId"
                              >
                              </ng-select>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="mb-1">
                              <label class="form-label" for="offerTitle"
                                >كود العرض</label
                              >
                              <input
                                type="text"
                                id="offerTitle"
                                class="form-control"
                                name="code"
                                formControlName="code"
                                placeholder="ادخل كود العرض"
                              />
                              <small
                                class="text-danger"
                                *ngIf="
                                  offerForm.get('code')?.hasError('required') &&
                                  offerForm.get('code')?.touched
                                "
                              >
                                هذا الحقل مطلوب
                              </small>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="mb-2">
                              <label class="form-label" for="redirectUtl"
                                >نسبه الخصم</label
                              >
                              <input
                                type="number"
                                id="redirectUtl"
                                class="form-control"
                                name="discount"
                                (input)="changeValue($event)"
                                formControlName="discount"
                                placeholder="ادخل نسبه الخصم"
                              />
                              <small
                                class="text-danger"
                                *ngIf="
                                  offerForm
                                    .get('discount')
                                    ?.hasError('required') &&
                                  offerForm.get('discount')?.touched
                                "
                              >
                                هذا الحقل مطلوب
                              </small>
                              <small
                                class="text-danger"
                                *ngIf="
                                  offerForm.get('discount')?.hasError('min') &&
                                  offerForm.get('discount')?.touched
                                "
                              >
                                يجب أن تكون النسبه أكبر من صفر
                              </small>
                              <small
                                class="text-danger"
                                *ngIf="
                                  offerForm.get('discount')?.hasError('max') &&
                                  offerForm.get('discount')?.touched
                                "
                              >
                                يجب أن تكون النسبه أقل من 100
                              </small>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="mb-2">
                              <label class="form-label" for="expiryDate"
                                >تاريخ انتهاء الصلاحية</label
                              >
                              <input
                                type="datetime-local"
                                id="expiryDate"
                                class="form-control"
                                name="expiryDate"
                                formControlName="expiryDate"
                                placeholder="ادخل تاريخ انتهاء الصلاحية"
                              />
                              <small
                                class="text-danger"
                                *ngIf="
                                  offerForm
                                    .get('expiryDate')
                                    ?.hasError('required') &&
                                  offerForm.get('expiryDate')?.touched
                                "
                              >
                                هذا الحقل مطلوب
                              </small>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div
                              class="custom-control custom-control-primary custom-switch"
                            >
                              <span class="mb-50 pr-1">تفعيل العرض</span>
                              <input
                                type="checkbox"
                                checked
                                class="custom-control-input"
                                id="customSwitch3"
                                (click)="changeState($event)"
                                name="isEnabled"
                                formControlName="isEnabled"
                              />
                              <label
                                class="custom-control-label"
                                for="customSwitch3"
                              ></label>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="modal-footer m-auto">
                      <button
                        type="button"
                        class="btn btn-success"
                        (click)="update()"
                        rippleEffect
                      >
                        تعديل
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        (click)="modal.close('Accept click'); reset()"
                        rippleEffect
                      >
                        تراجع
                      </button>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<ngb-toast
  *ngIf="toastService.message"
  [autohide]="true"
  (hidden)="toastService.clear()"
  style="position: fixed; left: 30px; top: 95px"
  delay="5000"
>
  <span style="color: #3f8260">{{ toastService.message }} </span>
  <!-- <i data-feather="check" class="mr-50"></i> -->
</ngb-toast>
